import React, { useEffect, useState } from "react";
import { PopupConfirm } from "../indexComponents";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faXmark } from "@fortawesome/free-solid-svg-icons";

function WeeklyGoals({ weeklyTasks, idTeam }) {
  const [tasks, setTasks] = useState(weeklyTasks ? weeklyTasks : []);
  const [isEditing, setIsEditing] = useState([]);
  const [isPopupDisplayed, setIsPopupDisplayed] = useState(false);
  const [hasDeleted, setHasDeleted] = useState(false);

  const handleAddTask = () => {
    setTasks([...tasks, { step: "", completed: false }]);
    const index = tasks.length;
    const updatedStatus = [...isEditing];
    updatedStatus[index] = true;
    setIsEditing(updatedStatus);
  };

  const handleTaskChange = (index, event) => {
    const updatedTasks = [...tasks];
    updatedTasks[index].step = event.target.value;
    setTasks(updatedTasks);
  };

  const handleSaveEdit = () => {
    if (isEditing.some((status) => status)) {
      handleSaveTasks();
      setIsEditing([]);
    }
  };

  const handleToggleTask = (index) => {
    const updatedTasks = [...tasks];
    updatedTasks[index].completed = !updatedTasks[index].completed;
    setTasks(updatedTasks);
    handleSaveTasks();
  };

  const handleDeleteObjective = (index) => {
    const tasksWithout = [...tasks];
    tasksWithout.splice(index, 1);
    setTasks(tasksWithout);
    setHasDeleted(true);
  };

  useEffect(() => {
    handleSaveTasks();
  }, [hasDeleted]);

  const handleWichToEdit = (index) => {
    const updatedStatus = [...isEditing];
    updatedStatus[index] = !updatedStatus[index];
    setIsEditing(updatedStatus);
  };

  const handleSaveTasks = async () => {
    try {
      const teamId = idTeam;

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/weekly-task/${teamId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify({
            weeklyTasks: tasks,
          }),
        }
      );
      if (!response.ok) {
        throw new Error("Failed to save weekly task");
      }
    } catch (error) {
      console.error("Error saving tasks:", error);
    }
  };

  return (
    <div className="WeeklyGoals" onMouseLeave={handleSaveEdit}>
      <h2>Objectifs de la semaine</h2>
      {tasks ? (
        <>
          {tasks.map((task, index) => (
            <div key={index} className="objective">
              <div className="checkbox-container">
                <input
                  id={`checkbox-${index}`}
                  type="checkbox"
                  checked={task.completed}
                  onChange={() => handleToggleTask(index)}
                  className="checkbox"
                />
                <label htmlFor={`checkbox-${index}`} />
              </div>
              {isEditing[index] ? (
                <textarea
                  type="text"
                  value={task.step}
                  onChange={(event) => handleTaskChange(index, event)}
                  className={`weekly-task-input ${isEditing ? "editing" : ""} ${
                    task.completed ? "completed" : ""
                  }`}
                  autoFocus={true}
                />
              ) : (
                <p
                  onClick={() => handleWichToEdit(index)}
                  className={`${task.completed ? "completed" : ""}`}
                >
                  {task.step}
                </p>
              )}
              {isPopupDisplayed ? (
                <PopupConfirm
                  text="Voulez-vous vraiment supprimer cette objectif ?"
                  textBtnConfirm="Supprimer"
                  onClickConfirm={() => {
                    handleDeleteObjective(index);
                    setIsPopupDisplayed(false);
                  }}
                  textBtnCancel="Annuler"
                  onClickCancel={() => {
                    setIsPopupDisplayed(false);
                  }}
                />
              ) : (
                <button
                  onClick={() => setIsPopupDisplayed(true)}
                  className="btn-supprimer"
                >
                  <FontAwesomeIcon icon={faXmark} />
                </button>
              )}
            </div>
          ))}
        </>
      ) : (
        ""
      )}

      <div className="btn-container">
        <button onClick={handleAddTask}>
          <FontAwesomeIcon icon={faPlus} />
        </button>
      </div>
    </div>
  );
}

export default WeeklyGoals;
